import { Typography } from '@mui/material';
import { useResponsive } from '@/components/hooks/useResponsive';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/seoSegmentationListingPage';

interface CaregiverLocationProps {
  address: NonNullable<Caregiver['member']['address']>;
}

export const CaregiverLocation = ({ address }: CaregiverLocationProps) => {
  const { isSmallViewport } = useResponsive();

  return (
    <Typography variant={isSmallViewport ? 'body3' : 'body2'}>
      {address.city}, {address.state}
    </Typography>
  );
};
